export default __webpack_public_path__ + "static/char-v-sp02-8e21e06bf7a0f11ae9d866e3ebc7359c.png";